import React from "react";
import { Button } from "@/components/ui/button";
import { PhoneCall } from "lucide-react";
import gafBadge from "@/assets/gaf-certified-badge.png";
import { usePhoneBar } from "@/contexts/PhoneBarContext";

export const CallToActionSection = () => {
  const { phoneNumber } = usePhoneBar();
  return (
    <>
      {/* Upper section with background and CTA */}
      <section className="py-16 bg-gradient-to-br from-blue-700 via-blue-800 to-blue-900 text-white relative overflow-hidden">
        <div className="container mx-auto px-4 text-center">
          {/* Main Call to Action */}
          <div className="max-w-3xl mx-auto mb-12">
            <h2 className="text-4xl md:text-5xl font-bold mb-8 leading-tight">
              Call Now For<br />A Quote!
            </h2>
            
            <Button
              asChild
              size="lg"
              className="bg-slate-800 hover:bg-slate-700 text-white px-8 py-6 text-xl font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
            >
              <a href={`tel:${phoneNumber}`} aria-label={`Call Safeway Roofing at ${phoneNumber.replace('+1', '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')}`}>
                <PhoneCall className="mr-3 h-6 w-6" />
                {phoneNumber.replace('+1', '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')}
              </a>
            </Button>
          </div>
        </div>
        
        {/* Background decoration */}
        <div className="absolute top-0 left-0 w-full h-full opacity-10">
          <div className="absolute top-10 left-10 w-32 h-32 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-10 right-10 w-40 h-40 bg-blue-300 rounded-full blur-3xl"></div>
        </div>
      </section>

      {/* Full-width image section */}
      <section className="relative">
        <div className="relative w-full">
          <div className="relative">
            <img 
              src="/images/projects/residential-roof-replacement.jpg"
              alt="Professional roofing work in progress"
              className="w-full h-64 md:h-80 object-cover"
            />
            
            {/* GAF Certified Badge - Positioned at top center, half above image */}
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
            <img 
              src={gafBadge}
              alt="GAF Certified Contractor"
              className="h-32 md:h-44 lg:h-48 w-auto filter brightness-110 drop-shadow-2xl"
            />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};